export const ROLES = ['admin','data','support','marketing'];

export const ROLE_LABELS = {
  admin:     'Admin',
  data:      'Data',
  support:   'Support',
  marketing: 'Marketing',
};

export const ROLE_COLORS = {
  admin:     '#314F5C',
  data:      '#1D9E75',
  support:   '#6F8FA7',
  marketing: '#534AB7',
};

export const ROLE_BG = {
  admin:     '#314F5C18',
  data:      '#1D9E7518',
  support:   '#6F8FA718',
  marketing: '#534AB718',
};

const ROLES_KEY = 'sanoire_team_roles';

export function getRoleMap() {
  try { return JSON.parse(localStorage.getItem(ROLES_KEY) || '{}'); } catch (_e) { return {}; }
}
export function saveRoleMap(map) {
  try { localStorage.setItem(ROLES_KEY, JSON.stringify(map)); } catch (_e) {}
}
export function getUserRole(email) {
  if (!email) return 'support';
  const map = getRoleMap();
  if (map[email]) return map[email];
  if (email.endsWith('@sanoire.com') || email.endsWith('@blynkstudio.com')) return 'admin';
  return 'support';
}
export function setUserRole(email, role) {
  const map = getRoleMap();
  if (role) map[email] = role; else delete map[email];
  saveRoleMap(map);
}

// Which nav screen IDs each role can access — null means everything
export const ROLE_NAV = {
  admin:     null,
  data:      new Set(['overview','sana','data','dataquality','locationeditor','duplicates',
               'coverage','pipeline','geocoding','verifyqueue','bulkeditor','locationprofile',
               'tagnormalizer','datacompleteness','coverageplanner','locationquality',
               'perf','system','activitylog','chat','languages','teamproductivity']),
  support:   new Set(['overview','users','userdetail','customerhelp','moderation','chat','activitylog',
               'notifications','nps','saved','travelprofiles','languages','journey','cohort']),
  marketing: new Set(['overview','sana','revenue','users','nps','retention','saved',
               'growth','waitlist','email','social','abtest','utm','chat','activitylog',
               'journey','cohort','peak','pushnotifications','userdetail']),
};

// Primary (always-visible) nav items per section — rest go behind '+ N more'
export const SECTION_PRIMARY = {
  'Analytics':      new Set(['overview','revenue','users','sana']),
  'Post-Launch':    new Set(['revenue','users','nps','retention']),
  'Data':           new Set(['data','dataquality','locationeditor']),
  'App Management': new Set(['passmanager','notices','featured','aiassistant']),
  'Operations':     new Set(['fraud','system']),
  'Growth':         new Set(['growth','waitlist','email']),
  'Team':           new Set(['customerhelp','chat','roles','activitylog']),
};
